/* Artisan Roast product page behaviour: variant matching, selling plans,
   tasting-note tabs. No dependencies; one file; nothing clever. */
(function () {
  'use strict';

  function init(root) {
    var form = root.querySelector('[data-ar-form], #ar-product-form');
    var variantsEl = root.querySelector('[data-ar-variants]');
    if (!form || !variantsEl) return;

    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[data-ar-variant-id]');
    var priceEl = root.querySelector('[data-ar-price]');
    var atc = form.querySelector('[data-ar-atc]');
    var moneyFormat = function (cents) {
      return 'RM' + (cents / 100).toFixed(2);
    };

    /* ----- variant matching from option radios ----- */
    function selectedOptions() {
      var opts = [];
      form.querySelectorAll('[data-ar-option-index]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        opts[parseInt(fs.dataset.arOptionIndex, 10)] = checked ? checked.value : null;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (val, i) {
          return val === null || v.options[i] === val;
        });
      });
    }

    function refresh() {
      var v = findVariant(selectedOptions());
      if (!v) {
        if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        var html = '';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<s>' + moneyFormat(v.compare_at_price) + '</s> ';
        }
        html += moneyFormat(v.price);
        priceEl.innerHTML = html;
      }
      if (atc) {
        atc.disabled = !v.available;
        atc.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      /* keep the URL shareable */
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    form.querySelectorAll('[data-ar-option-index] input').forEach(function (input) {
      input.addEventListener('change', refresh);
    });

    /* ----- native selling plans ----- */
    var planInput = form.querySelector('[data-ar-selling-plan]');
    var planSelect = form.querySelector('[data-ar-plan-select]');
    var toggles = form.querySelectorAll('[data-ar-plan-toggle]');

    function refreshPlan() {
      var subscribing = false;
      toggles.forEach(function (t) {
        if (t.checked && t.value === 'subscribe') subscribing = true;
      });
      if (planSelect) planSelect.disabled = !subscribing;
      if (planInput) planInput.value = subscribing && planSelect ? planSelect.value : '';
    }

    toggles.forEach(function (t) { t.addEventListener('change', refreshPlan); });
    if (planSelect) planSelect.addEventListener('change', refreshPlan);
    refreshPlan();

    /* ----- black / with-milk tabs ----- */
    var cup = root.querySelector('[data-ar-cup]');
    if (cup) {
      cup.querySelectorAll('[data-ar-cup-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var which = tab.dataset.arCupTab;
          cup.querySelectorAll('[data-ar-cup-tab]').forEach(function (t) {
            t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
          });
          cup.querySelectorAll('[data-ar-cup-panel]').forEach(function (p) {
            p.hidden = p.dataset.arCupPanel !== which;
          });
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[id^="ar-pdp-"]').forEach(function (pdp) {
      init(pdp.closest('section') || pdp);
    });
  });
})();
